define("shared/components/shared/post/secondary/hashtag-suggestions/modal-header", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--modalHeader u--m__b__0">
    <p class="o--modalHeader__title">
      {{t "shared_phrases.hashtag_suggestions"}}
      {{#if @showHelp}}
        <span class="u--float--right qa--hashtagSuggestions__helpIcon">
          {{svg-jar "help" class="o--icon--md o--icon--light"}}
          <EmberTooltip @side="left">
            <span class="qa--hashtagSuggestions__helpTooltip">
              {{t "hashtag_suggestions.tooltip"}}
            </span>
          </EmberTooltip>
        </span>
      {{/if}}
    </p>
  </div>
  */
  {
    "id": "kvb9qOe0",
    "block": "[[[10,0],[14,0,\"o--modalHeader u--m__b__0\"],[12],[1,\"\\n  \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"shared_phrases.hashtag_suggestions\"],null]],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[10,1],[14,0,\"u--float--right qa--hashtagSuggestions__helpIcon\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"help\"],[[\"class\"],[\"o--icon--md o--icon--light\"]]]],[1,\"\\n        \"],[8,[39,3],null,[[\"@side\"],[\"left\"]],[[\"default\"],[[[[1,\"\\n          \"],[10,1],[14,0,\"qa--hashtagSuggestions__helpTooltip\"],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"hashtag_suggestions.tooltip\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@showHelp\"],false,[\"t\",\"if\",\"svg-jar\",\"ember-tooltip\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/modal-header.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});